import { render, staticRenderFns } from "./purchaserecord.vue?vue&type=template&id=47ed354e&scoped=true"
import script from "./purchaserecord.vue?vue&type=script&lang=js"
export * from "./purchaserecord.vue?vue&type=script&lang=js"
import style0 from "./purchaserecord.vue?vue&type=style&index=0&id=47ed354e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47ed354e",
  null
  
)

export default component.exports